module.exports = "<span class=\"form-label__info-button-anchor js-anchor\"></span>";